export const blindModeOverrides = {
  sdk: {
    questions: {
      labelDocuments: {
        text: `
          <div style="font-family: 'Helvetica Neue', sans-serif; font-size: 13px; color: #000000; line-height: 20px;">
          <p style="font-weight: 500; font-style: normal; font-size: 13px; line-height: 16px; margin: 0 0 16px 0;">
          Ihre Unterlagen zum Vertrag<br/>
          Bitte speichern oder drucken Sie diese Papiere:
          </p>
          
          <ul style="padding-left: 20px; margin: 0 0 16px 0; list-style-type: disc;">
          <li>
          <strong>Vertrags-Unterlagen:</strong><br>
          <span style="color: #0066B3;">
          Das sind Infos für Verbraucher, zum Beispiel zur Kündigung, die Widerrufs-Belehrung und weitere Hinweise.
          Die Widerrufs-Belehrung enthält Informationen, wie Sie und innerhalb von welchem Zeitraum Sie den Vertrag rückgängig machen können.
          Das bedeutet, dass Sie sagen können, dass Sie die Versicherung doch nicht wollen.
          </span>
          </li>
          
          <li style="margin-top: 16px;">
          <strong>Tarifunterlagen:</strong><br>
          <span style="color: #0066B3;">
          Das sind die Allgemeinen Versicherungs-Bedingungen und das Produkt-Informations-Blatt.
          Die Regeln für eine Versicherung heißen Allgemeine Versicherungs-Bedingungen. Die Abkürzung lautet AVB.
          Das Versicherungs-Unternehmen muss sich an diese Regeln halten. Auch Sie müssen sich an diese Regeln halten.
          Die Regeln werden vom Versicherungs-Unternehmen aufgeschrieben. Sie gehören zu jedem Versicherungs-Vertrag dazu.
          <br><br>
          In den Allgemeinen Versicherungs-Bedingungen steht zum Beispiel:
          </span>
          <ul style="padding-left: 20px; list-style-type: disc; color: #0066B3;">
          <li>welche Schäden versichert sind</li>
          <li>welche Schäden nicht versichert sind</li>
          <li>was Sie machen müssen, wenn es einen Schaden gibt.</li>
          </ul>
          <span style="color: #0066B3;">
          Im Produkt-Informations-Blatt steht alles Wichtige über die Versicherung.
          Es soll Ihnen helfen, die Versicherung besser zu verstehen.
          </span>
          </li>
          
          <li style="margin-top: 16px;">
          <strong>Übersicht der Gesundheits-Fragen und der Angaben zum Versicherungs-Status:</strong><br>
          <span style="color: #0066B3;">
          Der Versicherungs-Status zeigt uns, welche Art von Schutz Sie haben.
          </span>
          </li>
          
          <li style="margin-top: 16px;">
          <strong>Datenschutz-Erklärung:</strong><br>
          <span style="color: #0066B3;">
          Das ist die Datenschutzrechtliche Einwilligungs- und Schweigepflicht-Entbindungs-Erklärung zu Ihren Gesundheitsdaten und sonstigen nach Paragraf § 203 Strafgesetzbuch geschützten Daten.
          Ihre Daten sind geschützt und wir dürfen Ihre Geheimnisse nicht weitererzählen (Schweigepflicht).
          In der Datenschutzrechtlichen Einwilligungs- und Schweigepflicht-Entbindungs-Erklärung zu Ihren Gesundheitsdaten und sonstigen nach Paragraf § 203 Strafgesetzbuch geschützten Daten
          erlauben Sie uns, wie wir Ihre Gesundheitsdaten nutzen. Und in welchen Fällen wir darüber sprechen oder schreiben dürfen.
          </span>
          </li>
          </ul>
          
          <p style="margin-top: 16px;">
          Diese Dokumente sind – neben dem Antrag, dem Versicherungs-Schein und etwaigen Nachträgen – Grundlage von Ihrem Versicherungs-Vertrag.<br/>
          Den Versicherungs-Schein erhalten sie gesondert von uns, wenn wir Ihren Antrag annehmen.
          </p>
          
          <p style="color: #0066B3; margin: 0;">
          Der Versicherungs-Schein ist ein Papier. Auf diesem Papier stehen wichtige Informationen über eine Versicherung. Zum Beispiel:
          </p>
          
          <ul style="padding-left: 20px; color: #0066B3; list-style-type: disc;">
          <li>wer die Versicherung abgeschlossen hat</li>
          <li>wann die Versicherung bezahlen muss.</li>
          </ul>
          
          <p style="color: #0066B3; margin-top: 0;">
          Deshalb ist das Papier besonders wichtig. Sie sollten den Schein sicher aufbewahren.
          Ein anderes Wort für Versicherungs-Schein ist Police.
          </p>
          </div>
          `,
        html: true,
      },
      policyHolderIsEqualInsuredPerson: {
        text: `
        <div style="font-family: 'Helvetica Neue', sans-serif; font-size: 13px; color: #000000; line-height: 20px;">
          <p style="font-weight: 500; font-style: normal; font-size: 13px; line-height: 20px; margin: 0 0 16px 0;">
            Ist die versicherte Person auch der Inhaber der Versicherung (Versicherungsnehmer)?:
          </p>

          <p style="color: #0066B3; margin: 0 0 16px 0;">
            Ein Mensch hat Versicherungs-Schutz. Die Versicherung zahlt dann für ihn. Wenn etwas passiert.
            Man sagt auch: Er ist die versicherte Person. Versicherte Personen stehen im Versicherungs-Vertrag.
          </p>

          <p style="color: #0066B3; margin: 0 0 16px 0;">
            Jemand hat einen Versicherungs-Vertrag abgeschlossen. Er ist dann der Versicherungs-Nehmer.
            Der Versicherungs-Nehmer muss einen Beitrag an die Versicherung zahlen.
            Und er kann den Vertrag kündigen oder ändern. Meistens ist die versicherte Person auch der Versicherungs-Nehmer.
            Manchmal ist die versicherte Person aber nicht der Versicherungs-Nehmer.
          </p>

          <p style="color: #0066B3; margin: 0 0 16px 0;">
            Zum Beispiel: Sie schließen für ihr Kind eine private Unfall-Versicherung ab.
            Ihr Kind ist dann die versicherte Person. Aber Sie sind der Versicherungs-Nehmer.
          </p>

          <p style="color: #0066B3; margin: 0;">
            Das heißt: Sie haben den Versicherungs-Vertrag abgeschlossen. Sie zahlen den Beitrag.
            Die Leistungen bekommt aber ihr Kind.
          </p>
        </div>
      `,
        html: true,
      },
      saveConfirmationtext: {
        text: `
    <div style="font-family: 'Helvetica Neue', sans-serif; font-size: 13px; color: #000000; line-height: 20px;">
      <p style="font-weight: bold; margin: 0;">
        Ich beantworte die Fragen wahrheitsgemäß und vollständig.
      </p>

      <p style="margin: 0;">
        Bitte beantworten Sie die Fragen wahrheitsgemäß und vollständig.
        Wenn Sie eine private Krankenversicherung abschließen wollen, müssen Sie dem Versicherungs-Unternehmen wichtige Dinge über Ihre Gesundheit sagen.
        Das nennt man Anzeige-Pflicht. Das Versicherungs-Unternehmen fragt Sie in einem Fragebogen nach Ihrem Gesundheits-Zustand.
        Es ist wichtig, dass Sie alle Fragen ehrlich und richtig beantworten. Sie müssen alles sagen, was Sie über Ihre Krankheiten und Behandlungen wissen.
        Wenn Sie dem Versicherungs-Unternehmen wichtige Dinge verschweigen oder falsche Angaben machen, nennt man das Anzeige-Pflicht-Verletzung.
        Das kann Probleme geben:
      </p>

      <ul style="padding-left: 20px; margin: 0; list-style-type: disc;">
        <li>Das Versicherungs-Unternehmen kann vom Vertrag zurücktreten. Das bedeutet, der Vertrag ist dann ungültig.</li>
        <li>Das Versicherungs-Unternehmen kann den Vertrag kündigen. Das bedeutet, der Vertrag wird beendet.</li>
        <li>Das Versicherungs-Unternehmen kann mehr Geld von Ihnen verlangen. Das nennt man Risikozuschlag.</li>
        <li>Das Versicherungs-Unternehmen muss vielleicht nicht bezahlen, wenn Sie krank werden.</li>
      </ul>

      <p style="margin: 0;">Das passiert, wenn die verschwiegene Krankheit mit der aktuellen Krankheit zusammenhängt.</p>
      <p style="margin: 0;">
      Ausführliche Hinweise zu den Anzeige-Pflichten und zu den Folgen einer Anzeige-Pflicht-Verletzung stehen in den 
      <a href="https://www.sdk.de/downloads/online-absatz/0.155a.pdf" target="_blank">Wichtigen Informationen für den Antragssteller</a>. Wenn Sie diesen Link anklicken, können Sie die Hinweise nachlesen.
      </p>
    </div>
  `,
        html: true,
      },
      declarationOfConsentTermsOfContract: {
        text: '<p style="font-weight: bold; margin: 0;">Ich habe die Allgemeinen Vertrags-Unterlagen und die Tarif-Unterlagen gelesen, abgespeichert oder ausgedruckt. Ich erkläre mich damit einverstanden. Ich stimme zu, dass der Versicherungs-Schutz unter Umständen schon vor Ablauf der Widerrufsfrist beginnt.</p>',
        html: true,
      },
      declarationOfConsentAndReleaseFromConfidentiality: {
        text: `
        <div style="font-weight: bold;">
        Ich bestätige, dass ich und alle in diesem Vertrag zu versichernden Personen die „Datenschutz- und Schweigepflicht-Entbindungs-Erklärung” ganz genau gelesen haben.
        <br /><br />
        <span style="color: #0066B3;">In der Datenschutz-Erklärung steht, was mit unseren Daten passiert. Mit der Schweigepflicht-Entbindung bestimmen wir, wem wir erlauben, über unsere Daten und Gesundheitsdaten zu sprechen oder zu schreiben.</span>
        <br /><br />
        Wir haben alles gelesen und sind damit einverstanden. Wir wissen, dass wir auch Nein sagen können und unsere Erlaubnis nicht geben müssen. Wir wissen auch, dass wir unsere Erlaubnis später ändern können. Das gilt dann für die Zukunft.
        <br /><br />
        Manchmal können versicherte Personen das nicht alleine verstehen. Zum Beispiel, wenn sie noch keine 16 Jahre alt sind. Dann bestätige ich: Die Eltern oder andere Erwachsene, die sich um diese Personen kümmern, haben die Erklärungen gelesen und ihre Erlaubnis gegeben.
        <br /><br />
        Diese Erklärungen gehören jetzt zu dem Antrag dazu. Sie sind ein wichtiger Teil davon.
        </div>
        `,
        html: true,
      },
      declarationOfConsentAdvertising: {
        text: `
        <div style="font-weight: bold; margin: 0; padding: 0; line-height: 1.7;">
        Ich bin einverstanden, dass die SDK Krankenversicherung oder eine Firma, die die SDK Krankenversicherung beauftragt hat, mich über Versicherungen der SDK Krankenversicherung informieren darf.<br>
        Das können sie tun per:
        <ul style="list-style-type: disc; padding-left: 1em; margin: 0;">
        <li style="margin: 0;">Telefon</li>
        <li style="margin: 0;">Brief</li>
        <li style="margin: 0;">E-Mail</li>
        <li style="margin: 0;">Nachrichten in sozialen Medien</li>
        </ul>
        Ich erlaube auch, dass der Außendienst der SDK Krankenversicherung und die Firmen, die die SDK Krankenversicherung beauftragt hat, über meinen Versicherungs-Vertrag informiert werden.<br>
        Meine besonderen Daten, die geheim bleiben müssen (geschützt nach Paragraf § 203 Strafgesetzbuch), dürfen an diese Personen weitergegeben werden. Das ist für Beratungen und Informationen über Produkte.<br>
        Ich befreie die Mitarbeiter der SDK Krankenversicherung von ihrer Pflicht, diese Daten geheim zu halten.<br>
        Ich kann diese Erlaubnis jederzeit widerrufen. Das hat keine Auswirkungen auf meinen Vertrag.
        </div>
        `,
        html: true,
      },
      orderZip: {
        text: `Post-Leit-Zahl:`,
      },
      policyHolderZip: {
        text: `Post-Leit-Zahl (VN):`,
      },
      policyHolderMobilNumber: {
        text: `Mobil-Telefon (VN):`,
      },
      mobilNumber: {
        text: `Telefon-Nummer:`,
      },
      sepaMandantConfirmation: {
        text: `
        <div>
        <b>SEPA-Lastschriftmandant</b><br><br>
        <div style="color: #0066B3;">
        Mit dieser Erlaubnis erlauben Sie der SDK Krankenversicherung und Ihrer Bank, Geld von Ihrem Konto abzubuchen.<br><br>
        Die SDK Krankenversicherung sagt Ihnen spätestens 5 Tage bevor das Geld abgebucht wird Bescheid<br><br>
        Wenn immer wieder der gleiche Betrag abgebucht wird, oder der Betrag feststeht, informiert die SDK Krankenversicherung Sie nur einmal vor der ersten Abbuchung. Die SDK Krankenversicherung sagt Ihnen dann auch, wann die weiteren Abbuchungen stattfinden.<br><br>
        Sie haben 8 Wochen Zeit, nachdem das Geld abgebucht wurde, um es zurückzufordern. Es gelten die Regeln, die Sie mit Ihrer Bank vereinbart haben.<br><br>
        Die Nummer der SDK Krankenversicherung, die zeigt, dass die SDK Krankenversicherung das Geld abbuchen darf, ist: DE62SDK00000062000
        </div><br>
        
        <div style="font-weight: bold; color: black;">
        Ich erlaube, dass wie oben beschrieben Geld von meinem Konto abgebucht wird.<br><br>
        Ich bestätige, dass ich das Recht habe, über das Konto auch alleine zu bestimmen.
        </div>
        </div>
        `,
        html: true,
      },
      G30: {
        text: `
        <div>
         <div style="font-weight: bold; color: black;">
          Fehlen Ihnen Zähne?<br/>
          Bitte geben Sie an, ob Ihnen Zähne fehlen, die noch nicht durch Zahnersatz (wie Brücken oder Implantate) dauerhaft ersetzt wurden.<br/><br/>
          - Zählen Sie bitte nur Zähne, die normalerweise nach den Milchzähnen kommen und keine Weisheitszähne sind.<br/>
          - Schreiben Sie die Anzahl der fehlenden Zähne auf, wenn Zähne fehlen.<br/>
          - Schreiben Sie "0" (Null) auf, wenn keine Zähne fehlen.<br/><br/>

          Wichtig: Wenn Ihnen mehr als 3 Zähne fehlen, können wir leider keinen Vertrag mit Ihnen abschließen.<br/><br/>

          Bitte beachten Sie: Für Zähne, die im Zeit-Punkt von Ihrem Antrag fehlen und noch nicht ersetzt wurden, übernehmen wir keine Kosten.<br/><br/>

          Das ist auch wichtig für Ihren Vertrag:<br/>
          Wir übernehmen keine Kosten für Zahnbehandlungen, die schon im Zeit-Punkt von Ihrem Antrag empfohlen, notwendig oder geplant waren.<br/><br/>

          Das gilt auch für:<br/>
          - Zahnersatz (zum Beispiel Kronen, Brücken, Implantate)<br/>
          - Behandlungen an Zähnen oder am Zahnfleisch (Parodontose)<br/>
          - Operationen an Zähnen oder am Kiefer<br/>
          - Zahn- oder Kiefer-Regulierungen (zum Beispiel Zahnspangen)
         </div>
        </div>
        `,
        html: true,
      },
    },
    picks: {
      default: [{ original: 'Zugestimmt', replacement: 'Einverstanden' }],
    },
  },
};
